<template>
    <v-app id='app' ref="mainApp" class="my-application">
        <div class="bkc_over bkc_over_image"></div>

        <v-app-bar v-if="!hideToolbars" app color="primary" dark class="headerTop" style="z-index:322;">


            <div class="d-flex align-center" v-if="viewLinkLogo">

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon id="no-background-hover" to="/dash">


                            <img :src="pathLogoImage" style="margin-left:13px;width:70px" />

                        </v-btn>
                    </template>

                    <span>Home</span>

                </v-tooltip>


            </div>

            <div class="d-flex align-center" v-if="!viewLinkLogo">

                <img :src="pathLogoImage" style="margin-left:13px;width:70px" />


            </div>






            <v-spacer></v-spacer>
            <div class="curDipOreTopEmt"> {{ curDipOreTop }} </div>

            <v-btn v-for="item in buttonsTop" :key="item.title" href="" text class="clStatusTS">
                <span class="mr-2"></span>
                <v-icon :color="item.color" :title="item.title">{{ item.icon }}</v-icon>
            </v-btn>

            <v-btn v-for="item in buttonsInsertTicketUser" :key="item.title" href="" text class="btnHolidaysUser2"
                @click="openPopupInsertTicketUser">
                <span class="mr-2"></span>

                <v-img class="  " contain src="@/assets/ticket2.png" max-width="30" max-height="30"
                    transition="scale-transition" style="margin-top:0px" title="Ticket" />

            </v-btn>


            <v-btn v-for="item in buttonsHolidaysUser" :key="item.title" href="" text class="btnHolidaysUser2"
                @click="openPopupHolidaysUserUser">
                <span class="mr-2"></span>

                <v-img class="  " contain src="@/assets/ferie_top.png" max-width="30" max-height="30"
                    transition="scale-transition" style="margin-top:2px" title="Informazioni Ferie/Permessi" />

            </v-btn>



            <v-btn v-for="item in buttonsInfoUser" :key="item.title" href="" text class="btnInfoUser2"
                @click="openPopupInfoUser">
                <span class="mr-2"></span>

                <v-img :alt="curDipTop" class="  " contain src="@/assets/profilo3.png" max-width="32" max-height="32"
                    transition="scale-transition" :title="curDipTop" />

            </v-btn>

            <span class="mr-2"></span>


        </v-app-bar>

        <v-main style="padding-bottoms:60px;">

            <router-view />

            <v-layout v-if="showProgress" class="progressBar" align-center justify-center column fill-height>
                <v-flex row align-center>
                    <v-progress-circular indeterminate :size="50" :color="colorProgress" class=""></v-progress-circular>
                </v-flex>
            </v-layout>

        </v-main>


        <template>
            <div v-if="prova" class="prova">Prova {{ prova }}</div>


            <v-bottom-navigation v-if="!hideToolbars" :background-color="'#a3a3a2'" style="z-index:3333;" dark fixed>


                <div class="wrap_buttons_footer">

                    <v-btn v-for="(item, i) in bnavbuttons" :key="i" :ref="'' + item.id" :disabled="false" :id="item.id"
                        @click="bottomIconsEvents($event)"
                        :class="item.disabled == true ? 'disable-events' : 'v-btn--actives'">

                        <v-icon v-if="!item.image" v-text="item.icon"></v-icon>


                        <img v-if="item.image && !item.width" :src="item.image" width="22" :id="item.id"
                            :class="item.class" :title="item.title" />

                        <img v-if="item.image && item.width" :src="item.image" :width="item.width" :id="item.id"
                            :class="item.class" :title="item.title" />

                    </v-btn>



                </div>



                <v-btn v-if="showButtonMenu" class="bottomBtnMenu" @click="openmenu">
                    <v-icon>mdi-menu</v-icon>
                </v-btn>

                <div v-if="showAziendaSelezionata" class="selectedCompanyEmt">

                    {{ nomeAziendaSelezionata }}

                </div>

                <div v-if="showAddressCompany" class="bottomContAddress">
                    <div style="display:flex;align-items:center;justify-content:end">
                        <v-img src="@/assets/building-for-home.png" max-width="10" max-height="10"
                            style="margin-right:5px" />
                        <div style="font-weight:900;font-size:12px">{{ companyName }}</div>
                    </div>
                    <div style="text-align:right;display:flex;align-items:center;justify-content:end">
                        <div style="font-size:9px;margin-right:5px">{{ companyAddress }}</div>
                        <v-img src="@/assets/telephone-for-home.png" max-width="10" max-height="10"
                            style="margin-right:5px" />
                        <div style="font-size:9px">{{ companyPhone }}</div>
                    </div>

                </div>




            </v-bottom-navigation>

            <aziende ref='mainAziende'></aziende>

            <menubottom ref="menubottom" v-if="renderMenu"> </menubottom>
            <backslider app="emt" ref="backslider"> </backslider>

        </template>


        <div class="contpopupinfouser" style="display:none">

            <template>
                <modal name="popupInfoUser" :clickToClose="false" :width="262" :height="215">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Informazioni Utente

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12" class="clRowInfoUser">

                            <div style="width: 80px;">Utente:</div>
                            <div style="font-weight: bold;">{{ curDipTop }}</div>

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12" class="clRowInfoUser">

                            <div style="width: 80px;">Ultimo Login:</div>
                            <div style="font-weight: bold;">{{ curDataOraLogin }}</div>

                        </v-col>

                    </v-row>


                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-info-user" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelInfoUser" />

                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contpopupholidayspermits" style="display:none">

            <template>
                <modal name="popupHolidaysPermits" :clickToClose="false" :width="224" :height="243">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;text-align: center;">

                            Ferie / Permessi

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12" class="clRowHolidaysPermitsUser">

                            <div style="width: 116px;">Ferie AC / AP (Ore):</div>
                            <div style="font-weight: bold;width: 69px;text-align: right;">{{ valFerieACAP }}</div>

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12" class="clRowHolidaysPermitsUser">

                            <div style="width: 116px;">Permessi AC / AP (Ore):</div>
                            <div style="font-weight: bold;width: 69px;text-align: right">{{ valPermessiACAP }}</div>

                        </v-col>

                    </v-row>


                    <v-row>

                        <v-col cols="12" md="12" class="clRowHolidaysPermitsUser">

                            <div style="width: 116px;">Totale (Ore):</div>
                            <div style="font-weight: bold;width: 69px;text-align: right">{{ valTotale }}</div>

                        </v-col>

                    </v-row>

                    <v-row v-if="redStatus">

                        <v-col cols="12" md="12" class="clRowHolidaysPermitsUser">

                            <div style="width: 116px;">Stato:</div>
                            <div
                                style="width: 69px;display:flex;justify-items: end;align-items: right;justify-content: right;">

                                <v-img alt="" src="@/assets/red_ball2.png" max-width="12" max-height="12" />

                            </div>

                        </v-col>

                    </v-row>

                    <v-row v-if="yellowStatus">

                        <v-col cols="12" md="12" class="clRowHolidaysPermitsUser">

                            <div style="width: 116px;">Stato:</div>
                            <div
                                style="width: 69px;display:flex;justify-items: end;align-items: right;justify-content: right;">

                                <v-img alt="" src="@/assets/yellow_ball2.png" max-width="12" max-height="12" />

                            </div>

                        </v-col>

                    </v-row>


                    <v-row v-if="greenStatus">

                        <v-col cols="12" md="12" class="clRowHolidaysPermitsUser">

                            <div style="width: 116px;">Stato:</div>
                            <div
                                style="width: 69px;display:flex;justify-items: end;align-items: right;justify-content: right;">

                                <v-img alt="" src="@/assets/green_ball2.png" max-width="12" max-height="12" />

                            </div>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-holidays-permits" contain
                                    src="@/assets/btn_cancel3_emt.png" max-width="30" max-height="30"
                                    style="cursor:pointer;color:black;margin-right:10px" transition="scale-transition"
                                    title="Annulla" @click="btnCancelHolidaysPermits" />

                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contpopupinsticket" style="display:none">

            <template>
                <modal name="popupInsTicket" :clickToClose="false" :width="354" :height="618">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;text-align: center">

                            Inserimento Ticket

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12" style="display:flex">

                            <div style="margin-left: 10px;width: 268px;">Codice Ticket:</div>

                            <div>{{ selCodeIssue }}</div>


                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">
                            <div id="cont_idissues_category" style="cursor:pointer">
                                <ion-item id="itemCategoria"
                                    style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                                    <ion-label style="font-size:12px;color:gray!important;opacity:1;cursor:pointer"
                                        position="floating">Categoria </ion-label>

                                    <ion-select id="idissues_category" name="idissues_category"
                                        class='idissues_category' cancel-Text="Chiudi" done-Text=""
                                        :value="selCategoria" interface="action-sheet">

                                        <ion-select-option v-for="item in categorie" :key="item.idissues_category"
                                            :value='item.idissues_category'> {{ item.description }}</ion-select-option>

                                    </ion-select>
                                </ion-item>
                            </div>

                        </v-col>

                    </v-row>

                    <v-row v-if="viewSottocategoria">

                        <v-col cols="12" md="12">
                            <div id="cont_idissues_subcategory" style="cursor:pointer">
                                <ion-item id="itemSottoCategoria"
                                    style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                                    <ion-label style="font-size:12px;color:gray!important;opacity:1;cursor:pointer"
                                        position="floating">SottoCategoria </ion-label>

                                    <ion-select id="idissues_subcategory" name="idissues_subcategory"
                                        class='idissues_subcategory' cancel-Text="Chiudi" done-Text=""
                                        :value="selSottoCategoria" interface="action-sheet">

                                        <ion-select-option v-for="item in sottocategorie"
                                            :key="item.idissues_subcategory" :value='item.idissues_subcategory'> {{
                                                item.description }}</ion-select-option>

                                    </ion-select>
                                </ion-item>
                            </div>

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-text-field v-model="selIssueName" label="Nome Ticket"></v-text-field>

                        </v-col>


                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-textarea v-model="selDescIssue" label="Descrizione"></v-textarea>

                        </v-col>

                    </v-row>


                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-holidays-permits" contain
                                    src="@/assets/btn_cancel3_emt.png" max-width="30" max-height="30"
                                    style="cursor:pointer;color:black;margin-right:10px" transition="scale-transition"
                                    title="Annulla" @click="btnCancelInsTicket" />

                                <v-img alt="" class="btn-confirm-holidays-permits" contain
                                    src="@/assets/btn_confirm3_emt.png" max-width="30" max-height="30"
                                    style="cursor:pointer;color:black;margin-right:10px" transition="scale-transition"
                                    title="Conferma" @click="btnConfirmInsTicket" />

                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contpopupinsticketadmin" style="display:none">

            <template>
                <modal name="popupInsTicketAdmin" :clickToClose="false" :width="354" :height="683">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;text-align: center">

                            Inserimento Ticket

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12" style="display:flex">

                            <div style="margin-left: 10px;width: 268px;">Codice Ticket:</div>

                            <div>{{ selCodeIssue }}</div>


                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">
                            <div id="cont_companyid2" style="cursor:pointer">
                                <ion-item id="itemAzienda"
                                    style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                                    <ion-label style="font-size:12px;color:gray!important;opacity:1;cursor:pointer"
                                        position="floating">Azienda </ion-label>

                                    <ion-select id="companyid" name="companyid" class='companyid' cancel-Text="Chiudi"
                                        done-Text="" :value="selAzienda" interface="action-sheet" disabled readonly>

                                        <ion-select-option v-for="item in aziende2" :key="item.companyid"
                                            :value='item.companyid'> {{ item.fld_name }}</ion-select-option>

                                    </ion-select>
                                </ion-item>
                            </div>

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">
                            <div id="cont_idissues_category" style="cursor:pointer">
                                <ion-item id="itemCategoria"
                                    style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                                    <ion-label style="font-size:12px;color:gray!important;opacity:1;cursor:pointer"
                                        position="floating">Categoria </ion-label>

                                    <ion-select id="idissues_category" name="idissues_category"
                                        class='idissues_category' cancel-Text="Chiudi" done-Text=""
                                        :value="selCategoria" interface="action-sheet">

                                        <ion-select-option v-for="item in categorie" :key="item.idissues_category"
                                            :value='item.idissues_category'> {{ item.description }}</ion-select-option>

                                    </ion-select>
                                </ion-item>
                            </div>

                        </v-col>

                    </v-row>

                    <v-row v-if="viewSottocategoria">

                        <v-col cols="12" md="12">
                            <div id="cont_idissues_subcategory" style="cursor:pointer">
                                <ion-item id="itemSottoCategoria"
                                    style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                                    <ion-label style="font-size:12px;color:gray!important;opacity:1;cursor:pointer"
                                        position="floating">SottoCategoria </ion-label>

                                    <ion-select id="idissues_subcategory" name="idissues_subcategory"
                                        class='idissues_subcategory' cancel-Text="Chiudi" done-Text=""
                                        :value="selSottoCategoria" interface="action-sheet">

                                        <ion-select-option v-for="item in sottocategorie"
                                            :key="item.idissues_subcategory" :value='item.idissues_subcategory'> {{
                                                item.description }}</ion-select-option>

                                    </ion-select>
                                </ion-item>
                            </div>

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-text-field v-model="selIssueName" label="Nome Ticket"></v-text-field>

                        </v-col>


                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-textarea v-model="selDescIssue" label="Descrizione"></v-textarea>

                        </v-col>

                    </v-row>


                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-holidays-permits" contain
                                    src="@/assets/btn_cancel3_emt.png" max-width="30" max-height="30"
                                    style="cursor:pointer;color:black;margin-right:10px" transition="scale-transition"
                                    title="Annulla" @click="btnCancelInsTicket" />

                                <v-img alt="" class="btn-confirm-holidays-permits" contain
                                    src="@/assets/btn_confirm3_emt.png" max-width="30" max-height="30"
                                    style="cursor:pointer;color:black;margin-right:10px" transition="scale-transition"
                                    title="Conferma" @click="btnConfirmInsTicket" />

                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>






        <div class="contcategorie">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetCategorie" class="vcategoriesheet" style="z-index: 9999;">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetCategorie" fixed style="position:fixed;">
                                Categorie
                                <v-btn class='closeSheet' icon @click="sheetCategorie = !sheetCategorie">
                                    <v-icon>mdi-close-circle-outline</v-icon>
                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line
                                        v-model="searchCategorie"></v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class="spacer" style="min-height:72px;"></div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredCategorie"
                                        :key="item.idissues_category" @click="manageClickCategorie(item)">

                                        <v-img alt="Categorie Logo" class="  " contain src="@/assets/categorie.png"
                                            max-width="24" max-height="24" transition="scale-transition" />

                                        <v-list-item-title class='itemCategoria'>{{ item.code }}</v-list-item-title>

                                    </v-list-item>
                                </v-card>
                            </v-flex>

                            <div style="min-height:170px;height:170px">&nbsp;</div>

                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>

        </div>


        <div class="contpopupticket" style="display:none">

            <template>
                <modal name="popupTicket" :clickToClose="false" :width="220" :height="225">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;text-align: center">

                            Ticket

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <div class="flex-center">

                                <v-radio-group v-model="valueSelected" row>

                                    <v-radio label="Inserimento" value="I" v-on:change="chgRadio"></v-radio>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <v-radio label="Vedi Tutti" value="V" v-on:change="chgRadio"></v-radio>

                                </v-radio-group>


                            </div>



                        </v-col>

                    </v-row>


                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-ticket" contain src="@/assets/btn_cancel3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelTicket" />

                                <v-img alt="" class="btn-confirm-ticket" contain src="@/assets/btn_confirm3_emt.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Conferma" @click="btnConfirmTicket" />

                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contaziende">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetAziende2" class="vaziendesheet" style="z-index: 9999;">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetAziende" fixed style="position:fixed;">
                                Aziende
                                <v-btn class='closeSheet' icon @click="sheetAziende2 = !sheetAziende2">
                                    <v-icon>mdi-close-circle-outline</v-icon>
                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line
                                        v-model="searchAzienda"></v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class="spacer" style="min-height:72px;"></div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredAziende2"
                                        :key="item.companyid" @click="manageClickAziende2(item)">

                                        <v-img alt="" src="@/assets/aziende-emt.png" max-width="24" max-height="24" />

                                        <v-list-item-title class='itemAzienda'>{{ item.fld_name }}</v-list-item-title>
                                        <v-icon class='iconPlusList'
                                            aria-hidden="false">mdi-plus-circle-outline</v-icon>
                                    </v-list-item>
                                </v-card>
                            </v-flex>
                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>

        </div>



    </v-app>
</template>

<script>

import backslider from "../../vuecommon/backslider";
import aziende from './components/aziende';
import menubottom from './components/menubottom';
import apitimesheet from "./utils/timesheet/apitimesheet";
import apiticket from "./utils/ticket/apiticket";


import {
    bus
} from './main'

import apiusers from "./utils/users/apiusers";


export default {

    mounted: function () {

        /*eslint-disable no-undef*/

        var pointerVue = this





        // window.addEventListener('contextmenu', this.disableContextMenu);

        // window.addEventListener('keydown', this.disableF12);


        document.title = "emt";


        var namesurname = window.$cookies.get("namesurname");


        this.fixBkc();

        this.curDipTop = namesurname;
        var token = window.$cookies.get("token");

        this.changeMenu();
        if (token !== null) {
            this.syncMonth();
            this.syncGroups();



        }

        $(document).ready(function () {


            $('body').on('click', '#cont_companyid2', function (event) {
                console.log(event);


                pointerVue.sheetAziende2 = true;

            });


            $('body').on('ionChange', '.idissues_category', function (event) {
                console.log(event);

                pointerVue.selCategoria = this.value;

                pointerVue.viewSottocategoria = true;

                setTimeout(() => {

                    pointerVue.loadSottoCategorie();

                }, 200);


            });

            $('body').on('ionChange', '.idissues_subcategory', function (event) {
                console.log(event);

                pointerVue.selSottoCategoria = this.value;

            });




        });




        setTimeout(

            function () {


            }, 50);


    },
    name: 'App',

    components: {

        aziende,
        menubottom,
        backslider

    },

    watch: {
        /*  hideToolbars: function(){
             console.log ("passed hide");
         }, */
    },

    methods: {

        manageClickAziende2: async function (azienda) {

            console.log("AZI SEL: ", azienda);

            this.sheetAziende2 = false;

            this.selAzienda = azienda.companyid;

            this.setCategorie(azienda.companyid);

        },


        chgRadio: function () {

            console.log("CHANGE: ", this.valueSelected);


        },

        btnCancelTicket: function () {

            this.$modal.hide('popupTicket');

        },

        btnConfirmTicket: function () {

            this.$modal.hide('popupTicket');

            if (this.valueSelected == "I") {

                this.initInsertTicket();

            }


            if (this.valueSelected == "V") {

                console.log("ok");

                this.makeUrlHdTool();


            }

        },

        makeUrlHdTool: async function () {


            var that = this;



            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;


            var response = await apiticket.createUlrFromProd(
                v_token
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from createUlrFromProd", res);

                window.open(res.data.ValUrl, "_blank");


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }

            );


        },

        insertTicket: async function () {

            var that = this;

            if (that.selIdAziDef != "") {
                that.ticket.companyid = that.selIdAziDef;
            }

            if (that.selCodeIssue != "") {
                that.ticket.code = that.selCodeIssue;
            }

            that.ticket.issuepriority = 1;

            if (that.selCategoria != "") {
                that.ticket.idissues_category = that.selCategoria;
            }

            if (that.selIssueName != "") {
                that.ticket.issuename = that.selIssueName;
            }

            if (that.selDescIssue != "") {
                that.ticket.description = that.selDescIssue;
            }



            var a = window.$cookies.get("a");


            if ((a == "S") || (a == "Y")) {
                that.$modal.hide('popupInsTicketAdmin');
            }

            if (a == "N") {
                that.$modal.hide('popupInsTicket');
            }




            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;


            response = await apiticket.insTicketApi(
                that.ticket,
                v_token,
                undefined,
                "B"
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from insTicketApi", res);

                that.$swal({
                    icon: "success",
                    text: "Ticket inserito correttamente, riceverà una mail di conferma",
                    showConfirmButton: false,
                    timer: 2000
                });



            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }

            );




        },

        btnConfirmInsTicket: function () {

            var that = this;

            var errore = "";

            var a = window.$cookies.get("a");

            if ((a == "S") || (a == "Y")) {

                if (that.selAzienda == "") {
                    errore = "Azienda richiesta";
                }

                if (errore == "") {
                    if (that.selCategoria == "") {
                        errore = "Categoria richiesta";
                    }
                }

                if (errore == "") {
                    if (that.selIssueName == "") {
                        errore = "Nome ticket richiesto";
                    }
                }

                if (errore == "") {
                    if (that.selDescIssue == "") {
                        errore = "Descrizione ticket richiesto";
                    }
                }


            }

            if (a == "N") {

                if (that.selCategoria == "") {
                    errore = "Categoria richiesta";
                }

                if (errore == "") {
                    if (that.selIssueName == "") {
                        errore = "Nome ticket richiesto";
                    }
                }

                if (errore == "") {
                    if (that.selDescIssue == "") {
                        errore = "Descrizione ticket richiesto";
                    }
                }


            }




            if (errore == "") {

                that.insertTicket();


            }
            else {
                that.$swal({
                    icon: "error",
                    text: errore,
                    showConfirmButton: false,
                    timer: 2000
                });

            }



        },


        loadSottoCategorie: async function () {

            var that = this;

            console.log("CATEGORY: ", that.selCategoria);



            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apiticket.getSottoCategorie(
                that.selCategoria
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from getSottoCategorie", res);

                this.sottocategorie = res.data.sottocategorie;

            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile caricare i dati");
                console.log("response", response);

            }

            );

        },


        manageClickCategorie: async function (categoria) {

            console.log("TIPO SEL: ", categoria);

            this.sheetCategorie = false;

            this.ticket.idissues_category = categoria.idissues_category;


        },

        setCategorie: function (id_azienda) {

            console.log("AZI SEL 2: ", id_azienda);

            console.log("DIP TMP: ", this.categorieTemp);

            var Categorie = [];

            for (var i = 0; i < this.categorieTemp.length; i++) {

                if (parseInt(this.categorieTemp[i].companyid) == parseInt(id_azienda)) {

                    Categorie.push({
                        idissues_category: this.categorieTemp[i].idissues_category,
                        description: this.categorieTemp[i].description,
                        code: this.categorieTemp[i].code,
                        companyid: this.categorieTemp[i].companyid
                    });

                }

            }

            console.log("DIP SEL: ", Categorie);

            this.categorie = Categorie;

        },


        initInsertTicket: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apiticket.initCreateTicketFromProd(
                v_token
            ).then((res) => {

                that.showSpinner = false;
                that.$root.$children[0].showProgress = false;
                console.log("res from initCreateTicketFromProd", res);

                that.aziende2 = res.data.company;

                that.selCodeIssue = res.data.codeTicket;

                //that.categorie = res.data.ticket_category;

                that.categorieTemp = res.data.ticket_category;

                that.selIdAziDef = res.data.id_azienda_def;

                // resetto campi di inserimento
                that.selCategoria = "";
                that.selSottoCategoria = "";
                that.selIssueName = "";
                that.selDescIssue = "";

                setTimeout(() => {

                    var a = window.$cookies.get("a");

                    if ((a == "S") || (a == "Y")) {

                        $(".contpopupinsticketadmin").show();

                        that.$modal.show('popupInsTicketAdmin');
                    }

                    if (a == "N") {


                        that.setCategorie(7);


                        $(".contpopupinsticket").show();

                        that.$modal.show('popupInsTicket');

                    }





                }, 200);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });


                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );


        },



        getTotalsHolidaysPermits: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apitimesheet.getTotalsHolidaysPermits(
                v_token
            ).then((res) => {

                that.showSpinner = false;
                that.$root.$children[0].showProgress = false;
                console.log("res from getTotalsHolidaysPermits", res);

                if (res.data.Result == "OK") {

                    that.valFerieACAP = res.data.TotFerie;

                    that.valPermessiACAP = res.data.TotPermessi;

                    that.valTotale = res.data.Totale;


                    that.redStatus = false;
                    that.yellowStatus = false;
                    that.greenStatus = false;

                    if (res.data.Stato == "RED_LEVEL") {
                        that.redStatus = true;
                    }

                    if (res.data.Stato == "YELLOW_LEVEL") {
                        that.yellowStatus = true;
                    }

                    if (res.data.Stato == "GREEN_LEVEL") {
                        that.greenStatus = true;
                    }

                    setTimeout(() => {


                        $(".contpopupholidayspermits").show();

                        that.$modal.show('popupHolidaysPermits');


                    }, 200);


                }
                else {


                    that.$swal({
                        icon: "error",
                        text: res.data.ErrDetails,
                        showConfirmButton: false,
                        timer: 3000
                    });




                }



            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });


                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );


        },


        btnCancelInsTicket: function () {

            var a = window.$cookies.get("a");


            if ((a == "S") || (a == "Y")) {
                this.$modal.hide('popupInsTicketAdmin');
            }

            if (a == "N") {
                this.$modal.hide('popupInsTicket');
            }



        },




        btnCancelHolidaysPermits: function () {

            this.$modal.hide('popupHolidaysPermits');

        },




        disableContextMenu(event) {
            event.preventDefault();
        },

        disableF12(event) {
            if (event.key === 'F12' || (event.ctrlKey && event.shiftKey && event.key === 'I')) {
                event.preventDefault();
            }
        },


        openPopupHolidaysUserUser: function () {

            this.getTotalsHolidaysPermits();

        },


        openPopupInsertTicketUser: function () {

            this.valueSelected = "I";

            $(".contpopupticket").show();

            this.$modal.show('popupTicket');

        },


        openPopupInfoUser: function () {

            $(".contpopupinfouser").show();

            this.$modal.show('popupInfoUser');

        },

        btnCancelInfoUser: function () {

            this.$modal.hide('popupInfoUser');

        },

        getUrlDomain: function (nome_metodo) {

            let result = "";

            if ($(location).attr('hostname') == "localhost") {
                result = $(location).attr('protocol') + "//emtool.local/";
            }

            if ($(location).attr('hostname') != "localhost") {

                result = $(location).attr('protocol') + "//" + $(location).attr('hostname') + "/";

            }

            return result + "" + nome_metodo;

        },

        getUrlDomainSimple: function (nome_metodo) {

            let result = "";

            if ($(location).attr('hostname') == "localhost") {
                result = $(location).attr('protocol') + "//emtool.local/";
            }

            if ($(location).attr('hostname') != "localhost") {

                result = $(location).attr('protocol') + "//" + $(location).attr('hostname') + "/";

            }

            return result + "" + nome_metodo;

        },

        fixBkc() {

            var settSmartinout = JSON.parse(window.$cookies.get("settEmtoolLogin"));

            console.log("OBJ SMARTINOUT: ", settSmartinout)

            if (settSmartinout != null) {


                var settings = settSmartinout[0];
                var backgroundImage = settings.backgroundImage;
                var txt_image = this.getUrlDomainSimple("public/documents/emtool/sfondi/" + backgroundImage);
                var rule = ` .bkc_over_image {background-image :url(` + txt_image + `)!important}`;


                console.log("RULE: ", rule);

                $('#addedCSS').text(rule);

            }


        },



        registerLogin: async function () {

            console.log("CHECK CONF");

            var that = this;

            var v_token = window.$cookies.get("token");


            var response = await apiusers.registerLoginNew(
                v_token,
                "emt"
            ).then((res) => {


                console.log("res from registerLoginNew", res);



            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }

            );


        },


        checkLogout: async function () {

            console.log("CHECK CONF");

            var that = this;

            var v_token = window.$cookies.get("token");


            var response = await apiusers.checkLogoutNew(
                v_token,
                "emt"
            ).then((res) => {


                console.log("res from checkLogoutNew", res);

                if (res.data.ForceLogout == 1) {

                    that.logout();

                }


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }

            );


        },



        setFieldActive(div) {

            $(div + " label").addClass("v-label--active");

        },

        setErrorField(div, msg_error) {

            var pointerVue = this;

            if (msg_error.length > 0) {

                pointerVue.addClassError(div);

                $(div + " .v-messages__wrapper").html(msg_error);

            }
            else {

                pointerVue.removeClassError(div);

                $(div + " .v-messages__wrapper").html("");

            }

        },

        initDivError(div, msg_error) {

            var pointerVue = this;

            // if (msg_error.length == 0) return false;

            $(div + " label").removeClass("v-label--active");

            window.msg_error = msg_error;

            $('body').on('blur', div, function (event) {

                console.log("EVENT: ", event);

                console.log("VALUE: ", $(div + " input").val());

                var valore = $(div + " input").val().replace("€", "").replace("$", "").trim();

                console.log("VALUE 2: ", valore);

                console.log("VALUE MSG ERROR: ", msg_error.length);

                if (msg_error.length > 0) {

                    if (valore == "") {

                        console.log("ADD CLASS");

                        pointerVue.addClassError(div);

                        $(div + " .v-messages__wrapper").html(msg_error);
                    } else {
                        console.log("REMOVE CLASS");

                        pointerVue.removeClassError(div);

                        $(div + " .v-messages__wrapper").html("");

                    }

                }
                else {

                    if (valore == "") {

                        $(div + " label").removeClass("v-label--active");

                    }

                }

            });

            $('body').on('focus', div, function (event) {

                console.log("EVENT: ", event);

                $(div + " label").addClass("v-label--active");

            });

        },

        addClassError(div) {

            //  alert("ok");

            // $(div +  " label").addClass("v-label--active error--text");
            $(div + " label").addClass("error--text");
            $(div + " label").removeClass("v-label--active");

            $(div).addClass("v-input v-input--has-state theme--light v-text-field v-text-field--is-booted error--text v-input--is-focused");

            $(div).removeClass("v-input--is-focused");

            $(div + " .v-messages").addClass("theme--light error--text");

        },

        removeClassError(div) {

            //  alert("ok");

            $(div + " label").removeClass("error--text");

            $(div).removeClass("v-text-field--is-booted error--text");

            $(div + " .v-messages").removeClass("error--text");

        },

        refreshMenu() {
            // Removing my-component from the DOM
            this.renderMenu = false;

            this.$nextTick(() => {
                // Adding the component back in
                this.renderMenu = true;
            });
        },

        openmenu: async function () {


            console.log("NAVBUTTONS: ", this.bnavbuttons);

            this.$refs.menubottom.sheetAziende = !this.$refs.menubottom.sheetAziende;

            if (this.$refs.menubottom.sheetAziende) // apro menu
            {

                this.old_bnavbuttons = this.bnavbuttons;

                this.bnavbuttons = null;

            } else {

                this.bnavbuttons = this.old_bnavbuttons;

            }


        },
        syncGroups: async function () {

            /*         var token =     window.$cookies.get("token");
                    var system =    window.$cookies.get("system"); */
            var username = window.$cookies.get("username");
            //atob
            var response;
            var arrTimesheet = [];

            try {
                response = await this.$api
                    .getgroups(username)
                    .then((res) => {
                        arrTimesheet = res.data.InfoUser;
                        console.log("InfoUser", arrTimesheet);

                        this.monthArray = arrTimesheet;

                        var result = Object.entries(arrTimesheet);
                        console.log(result);

                        var info_gruppi = arrTimesheet.gruppi;
                        this.gruppi = info_gruppi;

                        console.log("info_gruppi", info_gruppi);

                        //  var arrGruppi = [];
                        //var arrDipendenti = [];
                        //var aziende = Object.entries(arrTimesheet.aziende);

                        /*   for (var gr of info_gruppi) {
                              console.log("az", az);
                              arrAziende.push(az[1].fld_name);
                          }
                          if (arrAziende.length > 1 && !this.setupNavBottomDone) {
                              this.aziende = arrAziende;
                              this.dipendenti = arrDipendenti;
                              this.globalArrAziende = aziende;

                          }
                          console.log("arraz", arrAziende);
                          console.log("globalArrAziende", this.globalArrAziende); */
                        // this.syncMOnthIcons();
                    });
            } catch (error) {
                console.log(error);
            }

            console.log(response);

        },

        syncMsg: async function () {

            var token = window.$cookies.get("token");
            //   var system = window.$cookies.get("system");

            var response;
            var arrTimesheet = [];

            //  var today = new Date();
            // var curMonth = today.getMonth() + 1;
            // var curYear = today.getFullYear();


            try {

                response = await this.$api
                    .getMessagesApi(token, 0, 10)
                    .then((res) => {

                        //this.totalMsg = res.data.Messages.msg_tot_nr;

                        this.totalMsg = res.data.recordsTotal;

                        console.log("Timesheet", arrTimesheet);
                        // alert ( res.data.Messages.msg_tot_nr);

                    });
            } catch (error) {
                console.log(error);
            }

            //console.log(response);

            console.log("response from getMessagesApi", response);

        },


        loadLogo: async function () {

            var token = window.$cookies.get("token");

            try {
                var response = await this.$api
                    .LoadLogoCompany(token)
                    .then((res) => {

                        console.log("res LoadLogoCompany: ", res);

                        //this.pathLogoImage = "http://emtool.local/public/documents/LOGO_000008.gif";

                        this.pathLogoImage = res.data.UrlLogo;

                    });
            } catch (error) {
                console.log("err LoadLogoCompany", error);
            }

            console.log(response);



        },


        syncMonth: async function () {
            this.syncMsg();

            var token = window.$cookies.get("token");
            var system = window.$cookies.get("system");

            var response;
            var arrTimesheet = [];

            var today = new Date();
            var curMonth = today.getMonth() + 1;
            var curYear = today.getFullYear();

            try {
                response = await this.$api
                    .GetTimesheet(token, system, curYear, curMonth)
                    .then((res) => {
                        arrTimesheet = res.data.Timesheet;
                        console.log("Timesheet", arrTimesheet);

                        this.monthArray = arrTimesheet;
                        this.lista_orari = res.data.Timesheet.lista_orari;
                        console.log("this.lista_orari", this.lista_orari);

                        var result = Object.entries(arrTimesheet);
                        console.log(result);

                        var info_month = arrTimesheet.info_month;

                        // this.$root.$children[0].curDipTop = info_month.full_name;

                        if (!this.setupNavBottomDone) {
                            this.su = arrTimesheet.u_complete;
                            this.aa = arrTimesheet.az_complete;

                        }

                        this.curStatus = info_month.desc_stato;
                        this.curReadOnly = info_month.editable;
                        this.piano_orario = arrTimesheet.piano_orario;

                        console.log("info_month", info_month);

                        //aziende
                        var arrAziende = [];
                        var arrDipendenti = [];
                        var aziende = Object.entries(arrTimesheet.aziende);
                        //console.log ( "aziendeOK" , aziende );
                        for (var az of aziende) {
                            console.log("az", az);
                            arrAziende.push(az[1].fld_name);
                        }
                        if (arrAziende.length >= 1 && !this.setupNavBottomDone) {
                            this.aziende = arrAziende;
                            this.dipendenti = arrDipendenti;
                            this.globalArrAziende = aziende;

                        }
                        console.log("arraz", arrAziende);
                        console.log("globalArrAziende", this.globalArrAziende);
                        this.syncMOnthIcons();
                    });
            } catch (error) {
                console.log(error);
            }

            /*  this.showSpinner = false; */
            console.log(response);
            /*  this.resetSumDay();
             this.updateSumTotals();
             this.setupNavTop();
             this.setupNavBottom(); */

        },

        menuclick: function (slug) {
            //alert( slug );
            if (slug == 'timesheet?dip=1') {
                this.menuAziende = true;

                bus.$emit('menuClickEvent', "showaziende");

            } else {
                this.menuAziende = false;
            }
        },

        changeMenu: function () {

            //console.log ("items",this.items);

            // this.items = [];

            var a = window.$cookies.get("a");
            var b = window.$cookies.get("b");
            console.log(a, b);
            console.log("items", this.items);

            //Add menu for Admin
            /*  if (a == 'S' || a == 'Y' || b == 'S' || b == 'Y') {
                 this.items[2] = {
                     "id": 7,
                     "name": "Aziende",
                     "slug": "aziende",
                     "shown": 1,
                     "icon": "mdi-domain",
                     "children": [{
                         "icon": "mdi-account",
                         "id": 8,
                         "name": "Dipendenti",
                         "slug": "timesheet?dip=1",
                         "children": []
                     }]
                 };
             } else {
                 try {
                     //  delete (this.items[2]) ;
                     this.items.splice(2, 1);

                 } catch (error) {
                     console.log(error);
                 }
             } */

            //  alert (namesurname);
        },


        bottomIconsEvents(event) {
            // console.log (ist);
            var targetId = event.currentTarget.id;

            bus.$emit('bottomIconClickEvent', targetId);

        },
        setToolbar() {
            this.prova = false;
            // this.hideToolbars=true;
            //alert(1);
        },
        clickTimesheet() {
            //const elem = this.$refs.btnTimesheet;
            //elem.click()
            // console.log ( $event );
        },

        async profile() {
            /* if (this.totalMsg > 0 || this.totalMsg == '10+s')
                this.$router.push('/messages')
            else */
            this.$router.push('/profile')

        },

        async message() {

            this.$router.push('/messages')

        },


        logout: async function () {

            console.log("CHECK CONF");

            var that = this;

            var v_token = window.$cookies.get("token");

            var response = await apiusers.registerLogoutNew(
                v_token,
                "emt"
            ).then((res) => {

                console.log("res from registerLogoutNew", res);

                window.$cookies.remove("a");
                window.$cookies.remove("b");
                window.$cookies.remove("token");
                window.$cookies.remove("system");
                window.$cookies.remove("token_system");
                window.$cookies.remove("username");
                window.$cookies.remove("user_id");
                window.$cookies.remove("is_ebadge");

                window.$cookies.remove("namesurname");

                this.userLogged = false;
                this.$router.push('/')


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }

            );


        },




    },

    computed: {

        filteredAziende2() {

            return _.orderBy(this.aziende2.filter(item => {
                if (!this.searchAzienda) return this.aziende2;
                return (item.fld_name.toLowerCase().includes(this.searchAzienda.toLowerCase()));
            }), 'headline')
        },

        filteredCategorie() {

            return _.orderBy(this.categorie.filter(item => {
                if (!this.searchCategorie) return this.categorie;
                return (item.code.toLowerCase().includes(this.searchCategorie.toLowerCase()));
            }), 'headline')
        },

        msgFormatted: function () {
            if (this.totalMsg >= 10)
                return "10+";
            else
                return this.totalMsg;
        },
        showProva: {
            get() {
                return this.value
                // return true ;
            },
            set(value) {
                this.value = value
            }
        },
        hideToolbars() {
            if (this.$route.path == '/' || this.$route.path == '/register') {
                return true;
            } else {
                return false;
            }
        },

    },

    data: () => ({

        viewLinkLogo: true,

        categorieTemp: [],

        aziende2: [],

        sheetAziende2: false,

        searchAzienda: "",


        selAzienda: "",

        viewSottocategoria: false,

        valueSelected: "I",

        selCodeIssue: "",

        selIdAziDef: "",

        selIssueName: "",

        selDescIssue: "",

        selSottoCategoria: "",

        selCategoria: "",

        sottocategorie: [],

        searchCategorie: "",

        sheetCategorie: false,

        categorie: [],

        ticket: {},

        valFerieACAP: "",

        valPermessiACAP: "",

        valTotale: "",

        redStatus: false,
        yellowStatus: false,
        greenStatus: false,


        buttonsTop: [],

        nomeAziendaSelezionata: "",

        showAziendaSelezionata: false,

        curDataOraLogin: "",

        colorProgress: "primary",

        companyName: "",
        companyAddress: "",
        companyPhone: "",

        showAddressCompany: false,

        showButtonMenu: true,

        renderMenu: true,

        pathLogoImage: "",

        lista_orari: {},
        totalMsg: "",
        gruppi: [],
        aziende: [],
        dipendenti: [],
        globalArrAziende: {},

        curDipTop: "",
        curDipOreTop: "",
        curDipOreTopLabel: "",

        buttonsInfoUser: [{
            text: "",
            icon: "mdi-account",
            link: "",
            id: "btnInfoUser",
            disabled: false,
        }],


        buttonsHolidaysUser: [],

        buttonsInsertTicketUser: [],

        clipped: false,

        showProgress: false,

        prova: false,
        drawer: false,
        item: 1,
        items: [{
            "id": 1,
            "name": "User",
            "slug": "user",
            "icon": "mdi-account-circle",
            "children": [

                {
                    "id": 3,
                    "name": "Modify account",
                    "slug": "profile",
                    "icon": "mdi-account-circle",
                    "children": []
                },
                {
                    "id": 4,
                    "name": "Change password",
                    "slug": "changepassword",
                    "icon": "mdi-account-circle",
                    "children": []
                }

            ]
        },

        {
            "id": 5,
            "name": "Timesheet",
            "slug": "timesheet",
            "shown": 1,
            "icon": "mdi-timetable",
            "children": [{
                "icon": "mdi-timetable",
                "id": 6,
                "name": "Edit timesheet",
                "slug": "timesheet",
                "children": []
            }]
        },

            /*     {
                  "id": 7,
                  "name": "Messages",
                  "slug": "messages",
                  "icon" :"mdi-account-circle" ,
                  "shown":1,
                  "children": [
                    {
                      "id": 8,
                      "name": "List messages",
                      "slug": "List-messages",
                      "children": []
                    },
                    {
                      "id": 9,
                      "name": "Old messages",
                      "slug": "Old-messages",
                      "children": []
                    }
                  ]
                } */

            /*  {
             "id": 15,
             "name": "Info",
             "slug": "Info",
             "shown":1
             }, */

        ],
        itemsOK: [{
            text: 'Timesheet',
            icon: 'mdi-timetable',
            link: '/timesheet'
        },
        {
            text: 'Profile',
            icon: 'mdi-account-circle',
            link: '/profile',
            items: [{
                title: 'Home',
                action: 'fa-barcode',
                to: '/dash',
                icon: 'mdi-account-circle',
            }]
        },
            /*  { text: 'Logout', icon: 'mdi-logout-variant', link: '/' } */
        ],

        old_bnavbuttons: null,

        bnavbuttons: null,
        itemss: [{
            action: 'fa-chart-line',
            title: 'Dashboard',
            to: '/timesheet',
            icon: 'mdi-account-circle',
        },
        {
            action: 'fa-user',
            title: 'Attractions',
            icon: 'mdi-account-circle',
            items: [{
                title: 'Home',
                action: 'fa-barcode',
                to: '/dash',
                icon: 'mdi-account-circle',
            }]
        },

        ]

        /*   hideToolbars: false , */
        //
    }),

    props: {
        /*  ok: String */
    }
};
</script>





<style>
.flex-center {
    display: flex;
    flex-direction: column;
    align-items: center;
}


.clRowGreen {
    background: #e9f6ed !important;
}

.clRowYellow {
    background: #f3f5db !important;
}

.clRowMalattia {
    background: #f0e5f5 !important;
}

.clRowFest {
    background: #cde9f2 !important;
}



/* .clStatusTS {
    transform: translate(160px, 108px);
} */

.clStatusTS {
    transform: translate(157px, 108px);
}


.selectedCompanyEmt {
    position: fixed !important;
    padding-top: 22px;
    left: 0px;
    padding-left: 13px;
    font-weight: bold;
    font-size: 11px;
    color: black;
}


.btnInfoUser2 {
    transform: translateX(25px);
}

.btnHolidaysUser2 {
    transform: translateX(25px);
}

.clRowInfoUser {
    display: flex;
    margin-left: 10px;
}

.bkc_over {
    min-width: 100vw;
    min-height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: revert;
    position: absolute;
    opacity: 0.2;
}

.curDataOraLogin {
    color: black;
    margin-left: 10px;
    font-size: 8px;
}

.disable-events {
    pointer-events: none
}


.order-1 {
    order: 1;
}

.order-2 {
    order: 2;
}

.order-3 {
    order: 3;
}




.v-overflow {

    overflow-y: auto !important;
    padding-bottom: 115px !important;
    max-height: 100vh !important;

}

@media screen and (max-width: 768px) {

    .v-overflow {

        overflow-y: auto !important;
        padding-bottom: 175px !important;
        max-height: 100vh !important;

    }

    .clStatusTS {
        transform: translate(160px, 108px);
    }

}




ion-action-sheet {
    display: flex !important;
    position: fixed !important;
    top: 50vh !important;
}

ion-select {
    font-size: 10px;
}

table.dataTable.dtr-inline.collapsed>tbody>tr[role="row"]>td:first-child:before,
table.dataTable.dtr-inline.collapsed>tbody>tr[role="row"]>th:first-child:before {
    top: 25%;
    background-color: #a4a4b0;
    /* test */

}

table.dataTable.dtr-inline.collapsed>tbody>tr.parent>td:first-child:before,
table.dataTable.dtr-inline.collapsed>tbody>tr.parent>th:first-child:before {
    background-color: #f5cf2e;

}

.table-responsive {

    box-shadow: none;
    padding: 1px;
    min-height: 86vh;
}

.table td {
    padding: 3px 4px;

    vertical-align: middle;
}

.table thead th {
    padding: 3px;
}

#myTable_wrapper {
    max-height: 85vh;
    min-height: 300px;

    overflow-y: auto;
    overflow-x: hidden;
    /*  min-width: 90vw; */
    margin: 0 auto;

}

.inverted {
    filter: brightness(1) invert(1);
}

.btnTop {
    padding: 0px !important;
    min-width: 36px !important;
}

.curDipTopEmt {
    color: black;
    font-size: 10px;
    display: flex;
    align-content: center;
    padding: 0px;
    line-height: 10px;
    margin-left: 30px;
}

.curDipOreTopEmt {
    color: black;
    font-size: 10px;
    display: flex;
    align-content: center;
    line-height: 10px;
    min-height: 30px;
    display: flex;
    align-items: center;
    padding-top: 4px;
    transform: translateX(20px);
    font-weight: bold;

}

.cont_buttons {
    display: flex;
    align-items: center;
    float: left;
    min-width: 142px;
    padding-left: 10px;
    justify-content: inherit;

}

#myTable_filter {
    background-image: inherit !important;
    background: #f5cf2e;

    border: 1px solid black;
    align-items: center;
    display: flex;
    justify-content: space-between;
    /*    min-height: 60px; */
    position: relative;

}

.dataTables_filter label {
    /*   position: absolute;
    right: 6px;
    display: block; */
    margin-right: 4px;
    margin-bottom: 0px;
}

div.dataTables_wrapper div.dataTables_filter input {
    margin-left: 0.5em;
    display: inline-block;
    width: auto;
    z-index: 99999;
    min-width: 30px !important;
    min-height: 30px !important;
    background: white;
    border-radius: 50px;
}

#myTable_paginate {
    margin-top: 10px;
    display: flex;
    justify-content: center;

    /*    transform: translateX(-20px); */
}

.paginate_button {
    padding: 12px;
}

.curDipOreTopLabel {
    color: black;
    font-size: 10px;
    display: flex;
    align-content: center;

    line-height: 10px;
    min-height: 30px;
    display: flex;
    align-items: center;
    padding-top: 4px;
    transform: translateX(-10px);
    font-weight: bold;
}

.prova {
    color: black;
    background: red;
    font-size: 15px;
    z-index: 111111;
    text-align: center;
}

ion-item {
    font-size: 10px !important;
    transform: translateX(-16px);
}



:root {
    --ion-color-primary: #f5cf2e;
    --ion-font-family: "Montserrat", serif, sans-serif !important;
    --ion-font-size: 8px;
}


.v-toolbar__content,
.v-toolbar__extension {
    background: #f5cf2e;
    background: white;
}

.primary .v-btn>.v-btn__content .v-icon {
    color: black;
}

.v-toolbar__content a {
    color: white;
}

.v-btn:not(.v-btn--round).v-size--default {
    min-height: 56px;
    height: 56px;

}

.theme--dark.v-btn.v-btn--has-bg {
    background-color: inherit !important;
}

.wrap_buttons_footer {}


@media screen and (min-width: 768px) {

    #myTable_wrapper {
        /*  min-width: 700px; */
    }
}

@media screen and (max-width: 768px) {

    table.dataTable {
        /*  min-width: 98vw; */
    }

    .card,
    .card-body {
        padding: 0px;
    }

    #myTable_wrapper {
        /*min-width: 700px;*/
        box-sizing: border-box;
        /*  min-width: 100vw; */
        overflow-x: auto;
        /*  max-width: 90vw; */
        margin: 0 auto;

    }


    .wrap_buttons_footer {
        max-height: 60px;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        max-width: 256px;
        overflow-x: auto;
        overflow-y: hidden;
    }

    /* .clStatusTS {
        transform: translate(173px, 92px);
    } */


}

#myTable {

    overflow-x: auto;

}

input[type=search] {

    margin-left: 0px;
    min-width: 90px !important;
    max-width: 160px;
}

@media only screen and (max-width: 600px) {

    /*   .contListBookingRsa tbody {
        padding-top: 24px;
    } */

    #myTable {
        /*  margin-top: 72px; */
        /* transform: translateX(-12px); */

    }

    #myTable_filter {
        border-radius: 0px !important;
        position: fixed;
        width: 100%;
        left: 0px;
        z-index: 2;

    }

    .emt__footer {
        bottom: -1px;
    }

    /* For main Grid */
    .contListBookingRsa .table-responsive {
        /*  min-width: 91vw; */
        margin: 0 auto;

        padding: 0;
        position: fixed;
        left: 0px;
    }

    .cont_tickets {
        /*  left: 0;
        right: 0;
        position: absolute;
        top: 79px; */
    }

}
</style>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');
$font-family: 'Montserrat',
    serif;

.my-application * {
    font-family: $font-family, sans-serif !important;
}

.my-application {

    .headline,
    [class*='display-'],
    [class*='text-'] {
        /* color: #36405a; */
        font-family: $font-family, sans-serif !important;
    }

    font-family: $font-family,
    sans-serif !important;
    font-size:10px;
}

.contpopupinsticket label {
    font-size: 12px !important;
}

.v-navigation-drawer__content .v-list-item__title {
    font-size: 11px !important;
}

.headerTop {}

.v-badge__wrapper {
    right: auto;
    /* z-index: 1; */
    zoom: 1;
    transform: translateX(3px);
}

.v-badge__badge {
    color: black !important;
}

.imgProfile {
    /*   transform: translate(-6px,-2px); */
}

.btnProfile {
    /* margin-right: 4px; */
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
    display: none;
}

.bottomBtnMenu {
    position: fixed !important;
    right: 0px;
}

.bottomContAddress {
    position: fixed !important;
    right: 0px;
    padding-top: 9px;
    padding-right: 8px;
}




.v-dialog {
    transition: .05s cubic-bezier(.25, .8, .25, 1);
}

#myTable_filter .datetime-text {
    /*    max-width: 10px; */
    margin-left: 10px !important;
}

.cont-table {
    font-size: 10px;
    padding-top: 14px;
    margin: 0 auto;
}

table.dataTable.dtr-inline.collapsed>tbody>tr>td.dtr-control:before,
table.dataTable.dtr-inline.collapsed>tbody>tr>th.dtr-control:before {

    background-color: #a4a4b0;
}

td,
th {
    text-align: left;
}

#myTable_filter .datetime-text {
    font-size: 10px;
}

.card-body {
    background-color: #fff3;
}

tbody {
    background: #ffffff7a;
}

.paginate_button.disabled {
    visibility: hidden;
}

.active-row {
    background: transparent !important;
    border: 1px solid #00000087 !important;
}

.active-row-doxweb {
    background: #8ec8a3 !important;
    border: 1px solid #00000087 !important;
}

.active-row-doxweb-file {
    background: #8ec8a3 !important;
    border: 1px solid #00000087 !important;
}

#dataTables_filter label {
    padding: 0px;
}

#myTable_filter {
    min-height: 54px;
}


.theme--dark.v-app-bar.v-toolbar.v-sheet {
    box-shadow: none !important;
}

.order-1 {
    order: 1;
}

.order-2 {
    order: 2;
}

.order-3 {
    order: 3;
}
</style>
